export default __webpack_public_path__ + "f70f916ad1e693a0d46a80ab3a701b6c.png";